import { Icone } from './Icone.js';
import { useTema } from './tema.js';

/**
 * O alternador claro/escuro: dois botões, o do tema ativo marcado com
 * `aria-pressed`. Dois botões e não um interruptor porque o leitor de
 * tela anuncia "Tema escuro, ligado" — e a pessoa sabe o que vai
 * acontecer antes de apertar.
 */
export function TemaToggle() {
  const [tema, definir] = useTema();
  return (
    <div className="tema-toggle" role="group" aria-label="Tema">
      <button
        type="button"
        aria-label="Tema claro"
        aria-pressed={tema === 'light'}
        onClick={() => definir('light')}
      >
        <Icone nome="sol" />
      </button>
      <button
        type="button"
        aria-label="Tema escuro"
        aria-pressed={tema === 'dark'}
        onClick={() => definir('dark')}
      >
        <Icone nome="lua" />
      </button>
    </div>
  );
}
